import { j as c } from "./jsx-runtime-e6RZPHeG.js";
import { memo as v } from "react";
const i = ({
  title: e,
  titleId: l,
  ...o
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...o,
    children: [
      e ? /* @__PURE__ */ c.jsx("title", { id: l, children: e }) : null,
      /* @__PURE__ */ c.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M602.903 292.32H438.978v-36.267c0-20.032 16.235-36.267 36.288-36.267h91.371c20.011 0 36.267 16.235 36.267 36.267v36.267zm244.843 0h-174.4v-57.664c0-47.125-38.208-85.333-85.333-85.333H453.869c-47.125 0-85.333 38.208-85.333 85.333v57.664H192.003c-11.776 0-21.333 9.557-21.333 21.333v279.829c14.741 19.605 37.995 32.491 64.341 32.491h208.875v-5.931c0-12.971 10.517-23.488 23.467-23.488H574.51c12.949 0 23.488 10.517 23.488 23.488v5.931h208.875c26.368 0 49.6-12.885 64.341-32.491V315.786c0-12.949-10.517-23.467-23.467-23.467zM597.988 666.093v5.355c0 12.971-10.517 23.488-23.488 23.488H467.364c-12.949 0-23.488-10.517-23.488-23.488v-5.355H235.001c-23.467 0-45.419-6.485-64.32-17.579v177.621c0 35.349 28.651 64 64 64h572.544c35.328 0 64-28.651 64-64V648.514c-18.944 11.093-40.875 17.579-64.363 17.579z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = v(i);
export {
  m as default
};
